import React from "react";
import "./ProgressBar1.css";

const ProgressBar = ({ steps, currentStep, setStep }) => {
  const handleStepClick = (index) => {
    setStep(index + 1); // Allow navigation to any step
  };

  return (
    <ul id="progressbar">
      {steps.map((step, index) => (
        <li
          key={index}
          className={currentStep === index + 1 ? "active" : currentStep > index + 1 ? "completed" : ""}
          onClick={() => handleStepClick(index)}
        >
          <span>{index + 1}</span> {/* Show step number */}
          {step}
        </li>
      ))}
    </ul>
  );
};

export default ProgressBar;
